import { Space } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

export const Toolbar = observer(() => {
  // const { rentsReportStore: store } = useStore();

  return (
    <div>
      <Space>toolbar</Space>
    </div>
  );
});
